import http from "../httpService";
import {getBaseUrl} from "../../config";


export const submitBackOfficeReservation = data => {
  return http.post(
    `${getBaseUrl()}/back_office_reservation/${data.person_id}`,
    data
  );
};